import React from 'react';
import { makeStyles, Box, Grid } from '@material-ui/core';
const OurPackageCard = ({ item, index }) => {
	return (
		<>
			<Grid item xs={12} md={6} lg={4}>
			<div className='box' data-aos='fade-up' key={index} style={{padding:0}}>
				<div className='image'>
					<img src={item.image} alt='' />
					<h3>
						<i className='fas fa-map-marker-alt'></i> {item.title}
					</h3>
				</div>
				<div className='content'>
					<div className='price'>
						{item.discount} <span>{item.price}</span>
					</div>
					<p style={{ fontSize: 12, fontFamily: 'Poppins, sans-serif' }}>
						{item.desc}
					</p>
					<a href='#' className='btn' style={{borderRadius:10,fontSize:16}}>
						Book Now
					</a>
				</div>
			</div>
			</Grid>
		</>
	);
};

export default OurPackageCard;
